export default __webpack_public_path__ + "5d3b83e880e1d90db7e65a2f742986a3.svg";